import {useSuspenseQuery } from "@tanstack/react-query"
import { HOME_KEY } from "../constants/query.constants";
import { getHomeData } from "../repositories/home/homeRepository";

export const useHomeQuery = () => {
  return useSuspenseQuery({
    queryKey: [HOME_KEY],
    queryFn: getHomeData,
    staleTime: 1000 * 60 * 30, 
    gcTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    throwOnError : true
  });
};